import defined from './defined';
import Logging from './logging';

const VERSION_KEY = 'version';
const FAVORITES_KEY = 'favorites';

const currentSerializationVersion = 1;

const log = Logging.getLogger('app.core.localStorage');

export function serializeFavorites(locationInfos) {
  try {
    // Store a minimal subset of the data required to restore the favorites.
    // We don't want to get into the business of trying to store the complete
    // database info for this location since we can re-request it from the server.
    const reducedLocationInfos = locationInfos.reduce(
      (array, locationInfo) => {
        array.push({
          lat: locationInfo.location.lat,
          lon: locationInfo.location.lon,
          displayName: locationInfo.displayName,
        });
        return array;
      },
      []
    );

    const serializedData = JSON.stringify(reducedLocationInfos);

    localStorage.setItem(VERSION_KEY, currentSerializationVersion);
    localStorage.setItem(FAVORITES_KEY, serializedData);
  }
  catch (e) {
    // The browser may not support localStorage
    log.debug(`Failed to serialize favorites. Local Storage is not supported: ${e.message}`);
  }
}

export function deserializeFavorites() {
  try {
    const serializedVersion = localStorage.getItem(VERSION_KEY);
    const serializedData = localStorage.getItem(FAVORITES_KEY);

    // Return undefined instead of null of the localStorage is empty.
    // This forces redux to initialize the favorites reducer with its defined
    // initial state.
    let favorites = [];
    if (defined(serializedVersion) && defined(serializedData)) {
      const version = JSON.parse(serializedVersion);

      // We can hook in a migration scheme here in the future if we need to
      // change the format of serialized data.
      if (version === currentSerializationVersion) {
        favorites = JSON.parse(serializedData);
      }
    }
    return favorites;
  }
  catch (e) {
    // The browser may not support localStorage
    log.info(`Failed to deserialize favorites. Local Storage is not supported: ${e.message}`);
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/core/localStorage.js